import { useColorModeValue } from '@cardboard-ui/react';

interface NodeWithColors {
  readonly color: {
    readonly light: string;
    readonly dark: string;
  };
}

interface SpaceNode {
  readonly __typename: 'Space';
  readonly color: {
    readonly light: string;
    readonly dark: string;
  };
}

interface OtherNode {
  readonly __typename: '%other';
}

export const useSpaceColor = (
  space: NodeWithColors | SpaceNode | OtherNode | null | undefined,
  { invert = false } = {}
) => {
  const colors =
    space && 'color' in space && space.color
      ? space.color
      : { light: undefined, dark: undefined };

  const [light, dark] = invert
    ? [colors.dark, colors.light]
    : [colors.light, colors.dark];

  return useColorModeValue(light, dark);
};
